import React from "react";
import { Typography, withStyles } from "@material-ui/core";
import Text from "./Text";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";

export const StyledToggleButtonGroup = ({
  selection,
  handleSelection,
  options,
}) => {
  const StyledToggleButtonGroup = withStyles((theme) => ({
    root: {
      minHeight: 36,
      padding: "1px",
      width: "100%",
      backgroundColor: theme.palette.grey[300],
    },
    grouped: {
      margin: theme.spacing(0.5),
      border: "none",
      "&:not(:first-child)": {
        borderRadius: theme.shape.borderRadius,
      },
      "&:first-child": {
        borderRadius: theme.shape.borderRadius,
      },
    },
  }))(ToggleButtonGroup);

  const StyledToggleButton = withStyles((theme) => ({
    root: {
      margin: 3,
      display: "flex",
      flexGrow: 1,
      textTransform: "none",
      color: theme.palette.text.secondary,
      "&.Mui-selected": {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.text.title,
      },
      "&.Mui-selected:hover": {
        backgroundColor: theme.palette.grey[50],
      },
    },
  }))(ToggleButton);

  return (
    <StyledToggleButtonGroup
      value={selection}
      exclusive
      onChange={handleSelection}
    >
      {options.map((option, i) => (
        <StyledToggleButton key={`${i}-key`} value={option.value}>
          <Typography variant="body2">
            <strong>
              <Text tId={option.textId} />
            </strong>
          </Typography>
        </StyledToggleButton>
      ))}
    </StyledToggleButtonGroup>
  );
};
